'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _ALBUMS$ALBUMS_APP_DE;

var _consts = require('../consts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wixProvidersArray = [_consts.ART_STORE.PROVIDERS.WIX, _consts.ART_STORE.PROVIDERS.LOCAL];
var getProviderId = function getProviderId(connectedProviders) {
  return connectedProviders[(0, _keys2.default)(connectedProviders)[0]].providerId;
};
var fetchConnectedProvider = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url) {
    var response, data;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url);

          case 3:
            response = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return response.json();

          case 7:
            data = _context.sent;

            if (!(data && data.providerId)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt('return', (0, _defineProperty3.default)({}, data.providerId, data));

          case 10:
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](0);

            console.error(_context.t0);

          case 15:
            return _context.abrupt('return', null);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 12]]);
  }));

  return function fetchConnectedProvider(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = (_ALBUMS$ALBUMS_APP_DE = {}, (0, _defineProperty3.default)(_ALBUMS$ALBUMS_APP_DE, _consts.ALBUMS.ALBUMS_APP_DEF_ID, {
  getAdditionalParams: function getAdditionalParams(_ref3) {
    var albumId = _ref3.albumId,
        pricelistId = _ref3.pricelistId,
        freeArtStore = _ref3.freeArtStore;

    return {
      srcId: albumId,
      pricelistId: pricelistId,
      appDefId: _consts.ALBUMS.ALBUMS_APP_DEF_ID,
      isAlbumStore: true, //TODO: should be removed after all providers supports this'
      freeArtStore: freeArtStore
    };
  },
  getConnectedProviders: function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(instanceId, baseUrl) {
      var url;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = baseUrl + '/albums-node-server/api/getAlbumConnectedProvidersByArtStoreInstanceId?instanceId=' + instanceId;
              _context2.next = 3;
              return fetchConnectedProvider(url);

            case 3:
              return _context2.abrupt('return', _context2.sent);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function getConnectedProviders(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getInstanceFromSettings: function getInstanceFromSettings(settings) {
    return settings.albumId || settings.srcId;
  },
  getInvalidItemsForDownloadUrl: function getInvalidItemsForDownloadUrl(intanceId) {
    return '//progallery.wixapps.net/albums-node-server/api/itemsVerification?instanceId=' + intanceId;
  },
  getAdditionalQueryParams: function getAdditionalQueryParams(providerParams) {
    var appDefId = providerParams.appDefId,
        srcId = providerParams.srcId;

    return 'srcId=' + srcId + '&appDefId=' + appDefId;
  },
  getSectionsUrlWithParams: function getSectionsUrlWithParams(baseSectionsUrl, providerParams, connectedProviders) {
    var providerId = getProviderId(connectedProviders);
    if (!wixProvidersArray.includes(providerId)) {
      var appDefId = providerParams.appDefId,
          srcId = providerParams.srcId;
      var thank_you_page = baseSectionsUrl.thank_you_page,
          checkout_page = baseSectionsUrl.checkout_page;

      var queryParams = '?srcId=' + srcId + '&appDefId=' + appDefId;
      return {
        thank_you_page: {
          url: thank_you_page.url + queryParams
        },
        checkout_page: {
          url: checkout_page.url + queryParams
        }
      };
    }
    return baseSectionsUrl;
  },
  getSiteBusinessPackageData: function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(locale, srcId, baseUrl) {
      var url, response, retVal;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = baseUrl + '/albums-node-server/hasBusinessPackage?locale=' + locale + '&albumId=' + srcId;
              _context3.next = 3;
              return fetch(url, {
                method: 'GET'
              });

            case 3:
              response = _context3.sent;
              _context3.next = 6;
              return response.json();

            case 6:
              retVal = _context3.sent;
              return _context3.abrupt('return', {
                hasBusinessPackage: retVal.result,
                metaSiteId: retVal.metaSiteIdForPackage
              });

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function getSiteBusinessPackageData(_x4, _x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }(),
  getSitebusinessPlanUrl: function getSitebusinessPlanUrl(metaSiteId) {
    return 'https://www.wix.com/store/plans?siteGuid=' + metaSiteId + '&businessTab=true&referralAdditionalInfo=photoAlbums';
  }
}), (0, _defineProperty3.default)(_ALBUMS$ALBUMS_APP_DE, _consts.ART_STORE.ARTSTORE_APP_DEFINITION_ID, {
  getAdditionalParams: function getAdditionalParams() {
    return {};
  },
  getAdditionalQueryParams: function getAdditionalQueryParams() {
    return '';
  },
  getInstanceFromSettings: function getInstanceFromSettings() {},
  getConnectedProviders: function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(instance, baseUrl) {
      var url;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = baseUrl + '/_api/pro-gallery-webapp/v1/store/providers?instance=' + instance;
              _context4.next = 3;
              return fetchConnectedProvider(url);

            case 3:
              return _context4.abrupt('return', _context4.sent);

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function getConnectedProviders(_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }(),
  getSectionsUrlWithParams: function getSectionsUrlWithParams(baseSectionsUrl, _params, _connectedProviders) {
    return baseSectionsUrl;
  },
  getSiteBusinessPackageData: function getSiteBusinessPackageData() {},
  getSitebusinessPlanUrl: function getSitebusinessPlanUrl(_) {
    return '';
  }
}), _ALBUMS$ALBUMS_APP_DE);